export enum PricePlanProgramType {
  Program1 = "Program1",
  Program2 = "Program2",
  Program3 = "Program3",
  Program4 = "Program4",
  Program5 = "Program5",
  Program6 = "Program6",
  Program7 = "Program7",
  Program8 = "Program8",
  Program9 = "Program9",
  Program10 = "Program10",
  Program11 = "Program11",
  Program12 = "Program12",
  Program13 = "Program13",
  Program14 = "Program14",
  Program15 = "Program15",
  Program16 = "Program16",
  Program17 = "Program17",
  Program18 = "Program18",
  Program19 = "Program19",
  SameDay = "SameDay"
}
